import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ContractVehiclesPage from "@/pages/ContractVehiclesPage";

export const Route = createFileRoute("/contract-vehicles")({
  head: () => pageHead("Contract Vehicles", "AKIVA maintains multiple prime and subcontract vehicles across federal, state, and local government agencies for streamlined procurement.", "/contract-vehicles", false),
  component: ContractVehiclesPage,
});
